/// <reference types="vite/client" />
const API_BASE = import.meta.env.VITE_API_URL || "/api/v1";
class ApiError extends Error {
    status;
    constructor(message, status) {
        super(message);
        this.status = status;
        this.name = "ApiError";
    }
}
async function request(path, options = {}) {
    const token = localStorage.getItem("biotact_access_token");
    const headers = {
        "Content-Type": "application/json",
        ...(options.headers ?? {}),
    };
    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }
    const response = await fetch(`${API_BASE}${path}`, {
        ...options,
        headers,
    });
    if (response.status === 401) {
        localStorage.removeItem("biotact_access_token");
        window.location.href = "/login";
        throw new ApiError("Unauthorized", 401);
    }
    if (!response.ok) {
        const body = (await response.json().catch(() => ({})));
        throw new ApiError(body.detail ?? `HTTP ${response.status}`, response.status);
    }
    if (response.status === 204) {
        return undefined;
    }
    return (await response.json());
}
export const api = {
    get: (path) => request(path, { method: "GET" }),
    patch: (path, body) => request(path, { method: "PATCH", body: JSON.stringify(body) }),
    post: (path, body) => request(path, { method: "POST", body: JSON.stringify(body) }),
};
export { ApiError };
